<template>
  <!-- Page Container -->
  <div
    id="page-container"
    class="sidebar-o enable-page-overlay side-scroll page-header-fixed main-content-narrow sidebar-dark page-header-dark side-trans-enabled dark-mode"
  >
    <!-- Sidebar -->
    <Sidebar />
    <!-- End Sidebar -->
    <!-- Header -->
    <Header />

    <router-view />
    <!-- End Main Container -->
    <!-- Footer -->
    <Footer />
    <!-- End Footer -->
  </div>
  <!-- END Page Container -->
</template>

<script>
import { loadScript } from "vue-plugin-load-script";
import { onMounted } from "vue";
import { startMqttClient } from "@/composables/mqttClient.js";
import Sidebar from "@/components/Layout/Sidebar.vue";
import Header from "@/components/Layout/Header.vue";
import Footer from "@/components/Layout/Footer.vue";
import { watch } from "vue";
import useApp from "@/composables/useApp";

export default {
  components: {
    Sidebar,
    Header,
    Footer,
  },
  name: "defaultLayout",
  setup() {
    onMounted( () => {
      startMqttClient();
      loadScript("../../js/dashmix.app.min.js");
      
    });
    const {route} = useApp()
    watch(route, () => {
      if (window.innerWidth <= 990){
        setTimeout(()=>Dashmix.layout('sidebar_close'),400)
      }
    })
    return {
      //
    };
  },
};
</script>
